(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[71132,99252],{

/***/ 37814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Caret; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Caret() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0H256V256H0z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "16",
                d: "M96 48L176 128 96 208"
            })
        ]
    });
}


/***/ }),

/***/ 96119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ResolvedForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);



const FormNew = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(47341)]).then(__webpack_require__.bind(__webpack_require__, 47341)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47341)
            ]
    }
});
const FormOld = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(33646), __webpack_require__.e(44268), __webpack_require__.e(26569), __webpack_require__.e(198), __webpack_require__.e(3294), __webpack_require__.e(15818), __webpack_require__.e(14086), __webpack_require__.e(75108)]).then(__webpack_require__.bind(__webpack_require__, 75108)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(75108)
            ]
    }
});
function ResolvedForm(props) {
    const { loadOneToOneForm , domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    // The new form is the default for every domain. Keep the legacy form
    // available as an explicit per-domain escape hatch while one-to-one flows,
    // which are only implemented by the new form, always stay on FormNew.
    const useOldForm = !loadOneToOneForm && domain?.config?.forceOldForm === true;
    return useOldForm ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormOld, {
        ...props
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormNew, {
        ...props
    });
}


/***/ }),

/***/ 91354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProgressBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90796);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function ProgressBar({ total , current , className , color , backgroundColor , shift =0 , showStepNumberOnly =false , mode ="continuous" , title ="" , titleIcon , activeSegmentClassName =""  }) {
    const progress = (current + shift) / (total + shift - 1);
    const progressPercentage = Math.round(progress * 100);
    const hideStepsNumber = current + shift + 1 > total + shift - 1;
    if (mode === "steps") {
        const activeIndex = current + shift;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["top-progress-bar"])} ${className} ${activeIndex >= total - 1 ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().success) : ""}`,
            style: {
                backgroundColor
            },
            children: [
                (title || titleIcon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["progress-title"]),
                    children: [
                        titleIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["title-icon"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: titleIcon,
                                alt: title ?? "form icon",
                                height: "50px",
                                width: "50px"
                            })
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().segments),
                    children: Array.from({
                        length: total
                    }).map((_, index)=>{
                        const isActive = index <= activeIndex;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().segment)} ${isActive ? `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["active-segment"])} progressStepActive ${activeSegmentClassName}` : (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["inactive-segment"])}`
                        }, index);
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["progress-bar"])} ${className} ${progressPercentage === 100 ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().success) : ""}`,
        children: !showStepNumberOnly ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        left: progressPercentage ? `${progressPercentage}%` : 0,
                        transform: "translateX(-50%)",
                        background: color
                    },
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().percentage),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "text-xs",
                            children: [
                                progressPercentage,
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                borderBottomColor: color
                            },
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bar),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            width: `${progressPercentage}%`,
                            background: color
                        }
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: !hideStepsNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["step-number"]),
                children: [
                    current + shift + 1,
                    " of ",
                    total + shift - 1
                ]
            })
        })
    });
}


/***/ }),

/***/ 7665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MainBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/form/index.tsx
var shared_form = __webpack_require__(96119);
// EXTERNAL MODULE: ./src/page-builder/components/form/styles.module.scss
var styles_module = __webpack_require__(30422);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/page-builder/components/form/combinedForm/style.module.scss
var style_module = __webpack_require__(29168);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/components/shared/form/progressBar/index.tsx
var progressBar = __webpack_require__(91354);
// EXTERNAL MODULE: ./src/components/shared/combinedForm/icons/caret.tsx
var caret = __webpack_require__(37814);
;// CONCATENATED MODULE: ./src/page-builder/components/form/combinedForm/index.tsx








function CombinedForm(props) {
    const { form , updateForm , formattedTitle  } = (0,useDomainContext/* useDomainContext */.w)();
    const categories = props.formCategory?.categories ?? [];
    const { 0: isFormFetched , 1: updateFormFetched  } = (0,react.useState)(false);
    const { 0: currentStep , 1: setCurrentStep  } = (0,react.useState)(0);
    const { 0: formError , 1: updateFetchFormError  } = (0,react.useState)(null);
    const { 0: formLoading , 1: setFormLoading  } = (0,react.useState)(false);
    const getForm = async (categorySlug)=>{
        setFormLoading(categorySlug);
        const { data , error  } = await (0,api/* getDomainForm */.OU)({
            categorySlug
        });
        setFormLoading(false);
        if (error) {
            // @ts-ignore
            updateFetchFormError(error);
        }
        if (data) {
            updateFetchFormError(null);
            updateForm(data);
            updateFormFetched(true); // display form component
            setCurrentStep(1); // move next step
        }
    };
    const dynamicThankYouFields = (0,react.useMemo)(()=>{
        const dynamicThankYouFields = [];
        form?.steps.forEach((step)=>{
            step.fields.forEach((field)=>{
                dynamicThankYouFields.push(field.codeName);
            });
        });
        return dynamicThankYouFields;
    }, [
        form
    ]);
    const formContent = (0,react.useMemo)(()=>isFormFetched ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_form/* default */.Z, {
                ...props,
                classes: props.formClasses,
                colors: {},
                showProgress: true,
                progressShift: 1,
                backButton: {
                    class: `${(style_module_default())["back-button"]}`,
                    firstStepAction: ()=>{
                        setCurrentStep(0);
                    },
                    label: props?.backButtonText
                },
                preventWindowClose: true,
                stepsConfig: [
                    {
                        stepOrder: 0,
                        hideTitle: false,
                        hideDescription: false,
                        forceStepTitle: true
                    }, 
                ],
                dynamicThankYouFields: dynamicThankYouFields,
                progressBesideBackButton: props.progressBesideBackButton
            })
        }, form?.title) : null, [
        isFormFetched,
        form
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: props.formClassName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `${(style_module_default()).inner}`,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    transform: `translate(${currentStep * -100}%, 0)`
                },
                className: (style_module_default())["steps-wrapper"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(style_module_default()).stepBlock}`,
                        children: currentStep === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: (style_module_default()).title,
                                            dangerouslySetInnerHTML: {
                                                __html: formattedTitle ?? props.formCategory?.categoriesStepTitle ?? ""
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (style_module_default()).description,
                                            children: props.formCategory?.categoriesStepDescription
                                        })
                                    ]
                                }),
                                formError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).errorMessage,
                                    children: "Something went wrong"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: props.formCategory?.categoryListStyle === "list" ? (style_module_default())["categories-container-list"] : (style_module_default())["categories-container-grid"],
                                    children: categories?.map((item)=>{
                                        return item.slug ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: `${(style_module_default())["category-block"]} ${formLoading ? (style_module_default()).loading : ""}`,
                                            onClick: ()=>{
                                                if (item.slug) {
                                                    void getForm(item.slug);
                                                }
                                            },
                                            children: [
                                                item.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (style_module_default())["category-icon"],
                                                    children: formLoading === item.slug ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (style_module_default())["loader-container"],
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (style_module_default()).loader
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: item.icon,
                                                        alt: "",
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (style_module_default())["category-content"],
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (style_module_default())["category-title"],
                                                            children: item.title
                                                        }),
                                                        item?.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (style_module_default())["category-description"],
                                                            children: item?.description
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (style_module_default()).caret,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(caret/* default */.Z, {})
                                                })
                                            ]
                                        }, item.slug) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(progressBar/* default */.Z, {
                                    className: `${props.formClasses?.formProgressbarClassName ?? ""} ${(style_module_default())["custom-progress"]}`,
                                    current: 0,
                                    total: 8,
                                    color: undefined
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(style_module_default()).stepBlock}`,
                        children: currentStep === 1 && formContent
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/page-builder/components/affiliateOfferList/index.tsx + 2 modules
var affiliateOfferList = __webpack_require__(69629);
// EXTERNAL MODULE: ./src/page-builder/utils.ts
var utils = __webpack_require__(79961);
// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
;// CONCATENATED MODULE: ./src/page-builder/components/form/index.tsx












function MainBanner({ props ={}  }) {
    const classes = {
        stepTitleClassName: (styles_module_default())["step-title"],
        stepDescriptionClassName: (styles_module_default())["step-description"],
        formButtonClassName: (styles_module_default())["form-button"],
        formFieldClassName: (styles_module_default())["form-field"],
        formStepInnerClassName: (styles_module_default())["steps-inner"],
        stepClassName: (styles_module_default()).step,
        fieldsClassName: {
            radio: `${(styles_module_default())["radio-field"]} ${props.radioWithChecked ? (styles_module_default()).radioWithChecked : ""}`,
            checkbox: (styles_module_default())["checkbox-field"],
            select: (styles_module_default())["select-field"],
            streetAddress: (styles_module_default())["streetAddress-field"],
            date: (styles_module_default())["date-picker"],
            all: (styles_module_default()).field,
            range: (styles_module_default())["range-field"]
        },
        fieldsWrapperClassName: (styles_module_default())["fields-wrapper"],
        tcpaClassName: (styles_module_default()).tcpa,
        labelAsTitleClassName: (styles_module_default())["label-as-step-title"],
        fieldNoteClassName: (styles_module_default())["field-note"],
        fieldErrorMessageClassName: (styles_module_default())["field-error-message"],
        formProgressbarClassName: (styles_module_default()).progress,
        formTopProgressbarClassName: (styles_module_default()).topProgress,
        activeSegmentClassName: (styles_module_default())["active-segment"],
        sellingPointClassName: (styles_module_default())["selling-point"],
        formFieldLabelClassName: (styles_module_default())["field-label"],
        innerThankYouClassName: (styles_module_default()).thankYouStyle
    };
    const router = (0,next_router.useRouter)();
    const { category , visitDetails , domain , form  } = (0,useDomainContext/* useDomainContext */.w)();
    const formTemplate = (0,utils/* getFormTemplate */.uC)(router.asPath);
    const hideProgressFirstStep = (0,react.useMemo)(()=>{
        if (props?.hideProgressFirstStep) {
            return props?.hideProgressFirstStep === "true" ? true : false;
        }
        if (category?.config?.hideProgressFirstStep) {
            return true;
        }
        return false;
    }, []);
    const offersHeadlineTextBlock = domain.textBlocks?.find((i)=>i.position === "offers_headline");
    const displayForm = (0,sharedUtils/* finalShowForm */.r6)(router.query.sl, domain.showForm, domain.defaultOffers);
    if (!displayForm) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                ...(0,utils/* convertToBreakpointVariables */.Xz)({
                    buttonBackgroundColor: "#3ea636",
                    buttonHoverBackgroundColor: "#3ea636"
                })
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(affiliateOfferList["default"], {
                props: {
                    title: offersHeadlineTextBlock?.text,
                    maxNumberOfOffers: 1,
                    zone: config/* affiliateOfferZones.SWITCH_UI_LISTING */.ZR.SWITCH_UI_LISTING
                },
                inForm: true
            })
        });
    }
    const { formCategory  } = props;
    const dynamicThankYouFields = [];
    form?.steps.forEach((step)=>{
        step.fields.forEach((field)=>{
            dynamicThankYouFields.push(field.codeName);
        });
    });
    const isMultipleCategories = !props.usePostCategory && !formCategory?.auto && (formCategory?.categories?.length || 0) > 1;
    const sellingPoint = props.sellingPoint ? (0,sharedUtils/* replacePlaceholders */.wT)(props.sellingPoint, {
        category: category?.name,
        region: visitDetails?.region,
        city: visitDetails?.city
    }) : undefined;
    return isMultipleCategories ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `flex ${(styles_module_default())["form-wrapper"]}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CombinedForm, {
            ...props,
            formClasses: {
                ...classes
            },
            colors: {},
            sellingPoint: sellingPoint,
            formClassName: (styles_module_default()).form,
            formCategory: formCategory,
            formTemplateProp: formTemplate,
            resetLeadId: true,
            progressBesideBackButton: props.progressBesideBackButton
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `flex ${(styles_module_default())["form-wrapper"]}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_form/* default */.Z, {
            ...props,
            classes: {
                ...classes,
                formClassName: (styles_module_default()).form
            },
            dynamicThankYouFields: dynamicThankYouFields,
            backButton: {
                class: (styles_module_default())["back-button"],
                label: props?.backButtonText
            },
            formTemplateProp: formTemplate,
            colors: {},
            sellingPoint: sellingPoint,
            stepsConfig: [
                ...hideProgressFirstStep ? [
                    {
                        stepOrder: 0,
                        hideProgress: true
                    }, 
                ] : [], 
            ],
            progressBesideBackButton: props.progressBesideBackButton,
            progressPosition: props.progressPosition,
            progressMode: props.progressMode
        })
    });
}


/***/ }),

/***/ 90796:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","progress-bar":"styles_progress-bar__t428f","percentage":"styles_percentage__i1uhQ","arrow":"styles_arrow__EMmUy","bar":"styles_bar__g1uQX","segments":"styles_segments__tu7RY","segment":"styles_segment__JDFf_","top-progress-bar":"styles_top-progress-bar__eqW56","progress-title":"styles_progress-title__qNbAM"};

/***/ }),

/***/ 29168:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","steps-wrapper":"style_steps-wrapper__cx3Wn","stepBlock":"style_stepBlock__LTbRW","inner":"style_inner__hPd7P","custom-progress":"style_custom-progress__uubCs","title":"style_title__EaSf5","description":"style_description__sUZVS","errorMessage":"style_errorMessage__X0btP","back-button":"style_back-button__lvDOa","caret":"style_caret__R6T15","loading":"style_loading__SX_lJ","loader":"style_loader__mFy1C","rotation":"style_rotation__R8pX5","categories-container-grid":"style_categories-container-grid__KktsU","category-block":"style_category-block__uwIYm","category-icon":"style_category-icon__FJb_k","category-content":"style_category-content__tvU4L","category-title":"style_category-title__jNJxZ","category-description":"style_category-description__V_rqv","loader-container":"style_loader-container__SvVKv","categories-container-list":"style_categories-container-list__HeUr4"};

/***/ }),

/***/ 30422:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"styles_progress__MtACr","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","steps-inner":"styles_steps-inner__g5LuY","step-title":"styles_step-title__8h2cn","form-wrapper":"styles_form-wrapper__VbazA","label-as-step-title":"styles_label-as-step-title__hy53k","step-description":"styles_step-description__frnJF","fields-wrapper":"styles_fields-wrapper__9ncI2","field-note":"styles_field-note__dN4t2","field-error-message":"styles_field-error-message__sWVtd","tcpa":"styles_tcpa__G98ZI","topProgress":"styles_topProgress__K3C5I","active-segment":"styles_active-segment__2wqjf","back-button":"styles_back-button__ljzxi","thankYouStyle":"styles_thankYouStyle__PfRGz","form":"styles_form__sNIG3","form-button":"styles_form-button__PRvdF","form-field":"styles_form-field__SkTS2","radio-field":"styles_radio-field__m5TU2","radioWithChecked":"styles_radioWithChecked__VUzB_","checkbox-field":"styles_checkbox-field__yhvrx","date-picker":"styles_date-picker__Vxs1D","field":"styles_field__xfP96","range-field":"styles_range-field__JcEkW","selling-point":"styles_selling-point__rewLn","step":"styles_step__ZN15l","field-label":"styles_field-label__yAbeh","offersContainer":"styles_offersContainer__2F420"};

/***/ })

}]);